import React from "react";

/**
 * Reutilizable form field wrapper con label + help text.
 */
export function FormField({ label, children, help, testid }) {
  return (
    <div className="mb-3" data-testid={testid}>
      <label className="block text-xs uppercase tracking-widest text-gray-600 mb-1">{label}</label>
      {children}
      {help && <p className="text-[11px] text-gray-500 mt-1">{help}</p>}
    </div>
  );
}
